export const formatPhoneNumber = (phone?: string | null): string => {
    if (!phone) return '-';

    const normalized = phone.replace(/^[+]?81/, '0').replace(/[^0-9]/g, '');

    if (normalized.length === 11) {
        return normalized.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }

    if (normalized.length === 10) {
        return normalized.replace(/(\d{2,3})(\d{3,4})(\d{3,4})/, '$1-$2-$3');
    }

    return normalized || '-';
};
